import React, { useState } from 'react';
import * as S from './LegalMessage.styles';
import { ISite } from '../SiteList';

interface ILegalMessage {
  legalMessage: string;
  onSubmit: (site:ISite) => void;
  selectedSite: ISite;
}

const LegalMessage = (
    {legalMessage, onSubmit, selectedSite}: ILegalMessage
) => {
    const [showSubmit, setShowSubmit] = useState<boolean>(false);

    const handleCheck = () => {
        setShowSubmit(!showSubmit);
    };

    return (
        <S.Container>
            <S.Message>{legalMessage !== undefined ? legalMessage : 'Could not fetch legal message.'}</S.Message>
            <S.CheckboxWrapper>
                <S.Checkbox
                    data-testid="acknowledgeCheckbox"
                    type="checkbox"
                    checked={showSubmit}
                    onChange={handleCheck}
                />
                <S.CheckboxText>Yes</S.CheckboxText>
            </S.CheckboxWrapper>
            {showSubmit ? (
                <S.SubmitButtonWrapper>
                    <S.SubmitButton type="button" onClick={() => onSubmit(selectedSite)}>Continue</S.SubmitButton>
                </S.SubmitButtonWrapper>
            ): null}
        </S.Container>
    );};

export default LegalMessage;